export const handleRedirect = (url: string) => {
    window.open(`http://${url}`, '_blank')
};

export default handleRedirect;